import React from 'react';
import type { ViewProps } from 'react-native';
import { ScrollView } from 'react-native';

import type { CreditCardForm } from '@order/components';
import { CreditCardFormContent } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

export const SweetpassPaymentMethodAddScreenContent = ({
  testID,
  isAdding,
  onSave,
}: SweetpassPaymentMethodAddScreenContentProps) => {
  const { t } = useLocalizationContext();

  return (
    <ScrollView testID={testID}>
      <CreditCardFormContent
        vault="subscription"
        isVisible={true}
        title={t('sweetpass.signed-in.add-payment-method-title')}
        mode="add"
        excludedFields={['default', 'nickname']}
        isSaving={isAdding}
        onSave={onSave}
      />
    </ScrollView>
  );
};

// –––––––––––––––––––––––––––––––––––––––––––––––––––––

type SweetpassPaymentMethodAddScreenContentProps = {
  readonly isAdding: boolean;
  readonly onSave: (creditCardForm: CreditCardForm, nonce: string) => void;
} & Pick<ViewProps, 'testID'>;
